import {ref, computed, onMounted, onUnmounted} from '@vue/composition-api';
import {ShopsService} from '../../core/services'
const useGetShop = (shopId) => {


    const shop = ref(null)

    onMounted(async () => {
        shop.value = await ShopsService.getById(shopId)
    })

    return {
        shop
    }

}

export default useGetShop